<template>
<svg @mouseover="isHover=true" @mouseout="isHover=false"
   version="1.1"
   id="svg1825"
   xml:space="preserve"
   :width="width"
   :height="height"
   viewBox="2 2 71 71"
   sodipodi:docname="annotated biblography-button.ai"
   inkscape:version="1.1 (ce6663b3b7, 2021-05-25)"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs6"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath16"><path
         d="M 0,56.102 H 56.099 V 0 H 0 Z"
         id="path14" /></clipPath><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath44"><path
         d="M 1.95996,54.0659 H 54.4014 V 1.625 H 1.95996 Z"
         id="path42" /></clipPath></defs><sodipodi:namedview
     id="namedview4"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:pageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     showgrid="false"
     inkscape:zoom="11.283"
     inkscape:cx="37.401402"
     inkscape:cy="37.445716"
     inkscape:window-width="1848"
     inkscape:window-height="1016"
     inkscape:window-x="72"
     inkscape:window-y="27"
     inkscape:window-maximized="1"
     inkscape:current-layer="g8" />
     <g v-if="isHover"
     id="g8"
     inkscape:groupmode="layer"
     inkscape:label="impressum_mouse over"
     transform="matrix(1.3333333,0,0,-1.3333333,0,74.8028)"><g
       id="g10"><g
         id="g12"
         clip-path="url(#clipPath16)"><g
           id="g18"
           transform="translate(31.5615,21.5576)"><path
             d="m 0,0 c -4.654,0 -9.209,4.211 -9.209,9.132 0,4.92 2.338,8.537 9.209,8.683 C 4.658,17.914 8.435,13.828 8.435,8.908 8.435,3.987 4.659,0 0,0 m -13.503,27.497 -0.28,-35.744 25.613,0.406 0.888,35.236 z"
             style="fill:#e5d7d6;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path20" /></g><g
           id="g22"
           transform="translate(17.75,14.5947)"><path
             d="m 0,0 c 0,-1.252 -1.099,-1 -2.351,-1 h -1.881 c -1.253,0 -0.435,1.366 -0.435,2.618 V 33 c 0,1.253 -0.818,1.917 0.435,1.917 h 1.881 c 1.252,0 2.268,-1.015 2.268,-2.268 z"
             style="fill:#84bd9f;fill-opacity:1;fill-rule:evenodd;stroke:none"
             id="path24" /></g><g
           id="g26"
           transform="translate(14.0034,7.9951)"><path
             d="m 0,0 c -1.252,0 -1,1.099 -1,2.352 v 1.88 c 0,1.253 1.328,1.035 2.58,1.035 L 28.33,4.941 29.58,5.017 C 29.33,3.184 28.997,0.353 28.997,-0.9 L 10.413,-1.066 c 0,-0.538 -0.583,-1.5 -1.166,-1.334 -0.582,0.165 -1.373,-0.396 -2,-0.25 -0.489,0.113 -0.77,1.834 -1.084,1.834 z"
             style="fill:#84bd9f;fill-opacity:1;fill-rule:evenodd;stroke:none"
             id="path28" /></g><g
           id="g30"
           transform="translate(24.0835,36.2617)"><path
             d="m 0,0 c 2.75,3.417 6.998,3.167 8.25,3.167 l 5.833,-3.084 c 0.333,-1.166 2.5,-4.666 1.5,-8.25 L 12.417,-13.25 C 7.333,-16 3.667,-13.666 3.083,-13.5 2.501,-13.335 0.25,-11.083 -1,-8.583 -1.224,-8.135 -2.394,-2.974 0,0"
             style="fill:#84bd9f;fill-opacity:1;fill-rule:evenodd;stroke:none"
             id="path32" /></g><g
           id="g34"
           transform="translate(21.6563,5.5313)"><path
             d="M 0,0 C 0.158,0.899 0.827,0.457 1.49,0 2.118,0.864 2.473,1.999 2.237,3.728 H -0.746 C -0.337,2.643 -1.616,-0.126 0,0 M -8.248,7.474 C -8.438,5.873 -8.756,3.408 -8.35,2.798 -8.062,2.368 -3.52,1.622 -1.54,1.782 -1.157,2.663 -1.534,3.499 -2.353,3.917 -3.718,4.613 -6.149,4.179 -4.487,5.136 2.627,3.917 13.909,5.035 21.125,4.425 18.699,3.464 8.258,4.078 4.152,3.917 2.819,3.864 3.604,2.422 3.136,1.681 c 4.268,0.61 18.498,-0.566 18.191,0 -0.71,1.322 -0.304,3.659 0.509,5.691 -8.64,0 -21.241,-0.101 -30.084,0.102 m 4.777,35.979 c 0,-11.68 0.101,-23.689 0.101,-35.37 8.2,0 16.788,0.117 24.99,0.117 1.03,10.251 0.55,23.904 1.03,35.355 -8.45,0 -17.671,-0.102 -26.121,-0.102 m -4.73,-2.454 V 23.855 c 0,-4.78 -0.961,-14.247 -0.25,-15.263 0.704,-1.005 3.298,0.272 4.066,-0.203 0,8.132 0.508,26.831 -0.102,34.963 -0.744,0 -2.969,-0.115 -3.714,-0.115 z m 31.257,3.166 C 22.661,32.417 22.826,20.048 22.243,8.49 22.177,7.173 21.844,5.497 21.735,4.222 21.625,2.946 21.996,2.398 21.836,1.173 15.718,1.296 4.478,1.697 3.237,0.767 2.831,0.461 2.2,-0.21 1.713,-1.267 c -0.22,1.742 -2.121,1.64 -2.338,-0.101 -0.398,0.934 -0.711,2.033 -1.118,2.337 -0.837,0.628 -5.305,0.274 -7.203,1.267 -1.206,12.24 0.19,29.529 0,41.746 9.236,0.589 21.539,-0.29 32.002,0.183"
             style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
             id="path36" /></g><g
           id="g38"
           transform="translate(22.6572,30.3848)"><path
             d="M 0,0 C -0.129,-6.912 10.469,-12.907 15.348,-5.285 23.797,7.918 0.305,16.262 0,0 M 3.693,8.097 C 8.301,10.604 14.202,9.078 16.635,4.167 19.273,-1.16 15.656,-9.844 7.688,-9.088 0.117,-8.368 -4.211,3.797 3.693,8.097"
             style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
             id="path40" /></g><g
           id="g42"
           transform="translate(30.0088,33.3315)"><path
             d="M 0,0 C 1.442,0.291 2.439,0.271 3.329,-0.059 2.978,-2.236 2.401,-5.81 3.212,-9.065 2.101,-9.283 0.882,-9.283 -0.296,-8.915 0.585,-5.581 0.412,-2.149 0,0"
             style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
             id="path44" /></g><g
           id="g46"
           transform="translate(30.2886,36.9043)"><path
             d="M 0,0 C 0.805,0.29 2.16,0.154 2.825,-0.045 3.176,-0.862 3.041,-1.54 2.73,-2.387 1.862,-2.062 1.113,-2.09 -0.059,-2.349 -0.347,-1.607 -0.28,-0.93 0,0"
             style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
             id="path48" /></g><g
           id="g50"><g
             id="g52" /><g
             id="g64"><g
               clip-path="url(#clipPath56)"
               opacity="0"
               id="g62"><g
                 transform="translate(54.3545,2.5605)"
                 id="g60"><path
                   d="m 0,0 c 0,-0.418 -0.283,-0.759 -0.632,-0.759 h -51.175 c -0.352,0 -0.634,0.341 -0.634,0.759 v 50.926 c 0,0.421 0.282,0.757 0.634,0.757 H -0.632 C -0.283,51.683 0,51.347 0,50.926 Z"
                   style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none"
                   id="path58" /></g></g></g></g><g
           id="g66"
           transform="translate(54.3545,2.5605)"><path
             d="m 0,0 c 0,-0.418 -0.283,-0.759 -0.632,-0.759 h -51.175 c -0.352,0 -0.634,0.341 -0.634,0.759 v 50.926 c 0,0.421 0.282,0.757 0.634,0.757 H -0.632 C -0.283,51.683 0,51.347 0,50.926 Z"
             style="fill:none;stroke:#772e18;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path68" /></g></g></g></g>
    <g v-else
     id="g8"
     inkscape:groupmode="layer"
     inkscape:label="impressum_button"
     transform="matrix(1.3333333,0,0,-1.3333333,0,74.8028)"><g
       id="g10"><g
         id="g12"
         clip-path="url(#clipPath16)"><g
           id="g18"
           transform="translate(43.334,15.0283)"><path
             d="M 0,0 C 0,-4.426 0.166,-7.85 -0.501,-8.017 H -18.5 l -1.417,-1.833 -1.167,0.75 -1.083,-0.584 -1.25,1.75 -5.75,0.584 c -2.224,0 -1.167,2.924 -1.167,7.35 v 31.733 c -0.083,3.167 0.776,2.417 3,2.417 l 27.083,0.25 c 2.224,0 1.084,-3.238 1.084,-7.667 z"
             style="fill:#e5d7d6;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path20" /></g><g
           id="g22"
           transform="translate(31.5615,21.5576)"><path
             d="m 0,0 c -4.654,0 -9.209,4.211 -9.209,9.132 0,4.92 2.338,8.537 9.209,8.683 C 4.658,17.914 8.435,13.828 8.435,8.908 8.435,3.987 4.659,0 0,0 m -13.503,27.497 -0.28,-35.744 25.613,0.406 0.888,35.236 z"
             style="fill:#84bd9f;fill-opacity:1;fill-rule:nonzero;stroke:none"
             id="path24" /></g><g
           id="g26"
           transform="translate(21.6563,5.5313)"><path
             d="M 0,0 C 0.158,0.899 0.827,0.457 1.49,0 2.118,0.864 2.473,1.999 2.237,3.728 H -0.746 C -0.337,2.643 -1.616,-0.126 0,0 M -8.248,7.474 C -8.438,5.873 -8.756,3.408 -8.35,2.798 -8.062,2.368 -3.52,1.622 -1.54,1.782 -1.157,2.663 -1.534,3.499 -2.353,3.917 -3.718,4.613 -6.149,4.179 -4.487,5.136 2.627,3.917 13.909,5.035 21.125,4.425 18.699,3.464 8.258,4.078 4.152,3.917 2.819,3.864 3.604,2.422 3.136,1.681 c 4.268,0.61 18.498,-0.566 18.191,0 -0.71,1.322 -0.304,3.659 0.509,5.691 -8.64,0 -21.241,-0.101 -30.084,0.102 m 4.777,35.979 c 0,-11.68 0.101,-23.689 0.101,-35.37 8.2,0 16.788,0.117 24.99,0.117 1.03,10.251 0.55,23.904 1.03,35.355 -8.45,0 -17.671,-0.102 -26.121,-0.102 m -4.73,-2.454 V 23.855 c 0,-4.78 -0.961,-14.247 -0.25,-15.263 0.704,-1.005 3.298,0.272 4.066,-0.203 0,8.132 0.508,26.831 -0.102,34.963 -0.744,0 -2.969,-0.115 -3.714,-0.115 z m 31.257,3.166 C 22.661,32.417 22.826,20.048 22.243,8.49 22.177,7.173 21.844,5.497 21.735,4.222 21.625,2.946 21.996,2.398 21.836,1.173 15.718,1.296 4.478,1.697 3.237,0.767 2.831,0.461 2.2,-0.21 1.713,-1.267 c -0.22,1.742 -2.121,1.64 -2.338,-0.101 -0.398,0.934 -0.711,2.033 -1.118,2.337 -0.837,0.628 -5.305,0.274 -7.203,1.267 -1.206,12.24 0.19,29.529 0,41.746 9.236,0.589 21.539,-0.29 32.002,0.183"
             style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
             id="path28" /></g><g
           id="g30"
           transform="translate(22.6572,30.3848)"><path
             d="M 0,0 C -0.129,-6.912 10.469,-12.907 15.348,-5.285 23.797,7.918 0.305,16.262 0,0 M 3.693,8.097 C 8.301,10.604 14.202,9.078 16.635,4.167 19.273,-1.16 15.656,-9.844 7.688,-9.088 0.117,-8.368 -4.211,3.797 3.693,8.097"
             style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
             id="path32" /></g><g
           id="g34"
           transform="translate(30.0088,33.3315)"><path
             d="M 0,0 C 1.442,0.291 2.439,0.271 3.329,-0.059 2.978,-2.236 2.401,-5.81 3.212,-9.065 2.101,-9.283 0.882,-9.283 -0.296,-8.915 0.585,-5.581 0.412,-2.149 0,0"
             style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
             id="path36" /></g><g
           id="g38"
           transform="translate(30.2886,36.9043)"><path
             d="M 0,0 C 0.805,0.29 2.16,0.154 2.825,-0.045 3.176,-0.862 3.041,-1.54 2.73,-2.387 1.862,-2.062 1.113,-2.09 -0.059,-2.349 -0.347,-1.607 -0.28,-0.93 0,0"
             style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
             id="path40" /></g><g
           id="g42"><g
             id="g44" /><g
             id="g56"><g
               clip-path="url(#clipPath48)"
               opacity="0"
               id="g54"><g
                 transform="translate(54.3545,2.5605)"
                 id="g52"><path
                   d="m 0,0 c 0,-0.418 -0.283,-0.759 -0.632,-0.759 h -51.175 c -0.352,0 -0.634,0.341 -0.634,0.759 v 50.926 c 0,0.421 0.282,0.757 0.634,0.757 H -0.632 C -0.283,51.683 0,51.347 0,50.926 Z"
                   style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none"
                   id="path50" /></g></g></g></g><g
           id="g58"
           transform="translate(54.3545,2.5605)"><path
             d="m 0,0 c 0,-0.418 -0.283,-0.759 -0.632,-0.759 h -51.175 c -0.352,0 -0.634,0.341 -0.634,0.759 v 50.926 c 0,0.421 0.282,0.757 0.634,0.757 H -0.632 C -0.283,51.683 0,51.347 0,50.926 Z"
             style="fill:none;stroke:#772e18;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path60" /></g></g></g></g>
    <title
      :id="iconName"
      lang="en"
    >Impressum</title>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box'
    },
    width: {
      type: [Number, String],
      default: 56
    },
    height: {
      type: [Number, String],
      default: 56
    },
    iconColor: {
      type: String,
      default: '#84bd9f'
    }
  },
  data () {
    return {
      isHover:false,
    }
  }
}
</script>